import { Injectable } from '@angular/core';
import { SysuserServicePkg } from './sysuserPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SysuserService extends SysuserServicePkg {
  constructor() {
    super();
  }
}
